import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JobseekerSkillViewModel, UserTypeEnum } from '@hrra/common-models';
import { ButtonTypeAttributeEnum, ButtonTypeEnum } from '@hrra/ui';

export interface SkillsFilterDialogData {
  title: string;
  skills: JobseekerSkillViewModel[];
}

//popup listing every chosen skill; opened from the "all" link when the filter clamps the chips
//holds its own draft copy and returns the final list through the dialog result, so hosts only
//need to react to a single value on close
@Component({
    selector: 'hrra-skills-filter-dialog',
    templateUrl: './skills-filter-dialog.component.html',
    styleUrls: ['./skills-filter-dialog.component.scss'],
    standalone: false
})
export class SkillsFilterDialogComponent {
  public draftSkills: JobseekerSkillViewModel[];

  public buttonType: any = ButtonTypeEnum;
  public buttonAttributeType: any = ButtonTypeAttributeEnum;
  public userType: any = UserTypeEnum;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SkillsFilterDialogData,
    public dialogRef: MatDialogRef<SkillsFilterDialogComponent, JobseekerSkillViewModel[]>
  ) {
    this.draftSkills = [...(this.data.skills ?? [])];
  }

  removeSkill(index: number) {
    this.draftSkills = this.draftSkills.filter((_, i) => i !== index);
  }

  clearAll() {
    this.draftSkills = [];
  }

  save() {
    this.dialogRef.close(this.draftSkills);
  }
}
